import React from "react";
import { FaTimes, FaPaperclip, FaRegImage } from "react-icons/fa";
import "./CorporatePageElementsCss/CorporateViewModal.css";

const CorporateViewModal = ({ open, onClose, reports = [] }) => {
  if (!open) return null;

  //   const billTitle = reports && reports.length > 0 ? (reports[0].BillNo || reports[0].AccNo || "-") : "-";

  return (
    <div className="cv-overlay" role="dialog" aria-modal="true">
      <div className="cv-modal">
        <div className="cv-header">
          <h3 className="cv-title">
            Report Details of {reports[0]?.BillID || "-"}
          </h3>
        </div>

        <button className="cv-close" onClick={onClose} aria-label="Close">
          <FaTimes />
        </button>

        <div className="cv-content">
          <table className="cv-table">
            <thead>
              <tr className="cv-table-headrow">
                <th>Tests</th>
                <th>Reports</th>
                <th>Image</th>
                <th>Attachment</th>
              </tr>
            </thead>
            <tbody>
              {reports && reports.length > 0 ? (
                reports.map((r, idx) => {
                  const isCompleted =
                    r?.ReportStatus &&
                    String(r.ReportStatus).toLowerCase() === "completed";
                  return (
                    <tr key={idx} className="cv-table-row">
                      <td className="cv-testname">
                        {r.TestName || r.Test || "-"}
                      </td>
                      <td className="cv-reports">
                        {isCompleted && r.report_image_url ? (
                          <a
                            href={r.report_image_url}
                            target="_blank"
                            rel="noreferrer"
                            className="cv-link"
                          >
                            View Report
                          </a>
                        ) : (
                          <span className="cv-link muted">
                            {isCompleted ? "View Report" : "Pending"}
                          </span>
                        )}
                        <br />
                        {isCompleted && r.report_image_url_print ? (
                          <a
                            href={r.report_image_url_print}
                            target="_blank"
                            rel="noreferrer"
                            className="cv-link"
                          >
                            View Report Without Header
                          </a>
                        ) : null}
                      </td>
                      <td className="cv-image">
                        {Array.isArray(r.Image_files_url) &&
                        r.Image_files_url.length > 0 ? (
                          r.Image_files_url.map((img, i) => (
                            <a
                              key={i}
                              href={img.ImageFile}
                              target="_blank"
                              rel="noreferrer"
                              className="cv-image-link"
                              title="View Image / Attachment"
                            >
                              <FaRegImage />
                            </a>
                          ))
                        ) : (
                          <span className="cv-empty">-</span>
                        )}
                      </td>

                      <td className="cv-attachment">
                        {r.Attachment_url ? (
                          <a
                            href={r.Attachment_url}
                            target="_blank"
                            rel="noreferrer"
                            className="cv-attach"
                          >
                            <FaPaperclip />
                          </a>
                        ) : (
                          <span className="cv-empty">-</span>
                        )}
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={4} className="cv-no-items">
                    No reports available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default CorporateViewModal;
